export const SMART_LINKS_VIEW_PATH: string = "/sl";
export const CREATE_SMART_LINK_VIEW_PATH: string = "/sl/create";
export const SMART_LINK_DETAIL_VIEW_PATH: string = "/sl/:smartLinkUuid";
export const EDIT_SMART_LINK_VIEW_PATH: string = "/sl/:smartLinkUuid/edit";
